import { Button, Typography } from "@suraasa/placebo-ui"
import PageContainer from "components/PageContainer"

const getSupportEmailURI = () => {
  const subject = encodeURIComponent("Issue with Assessment")
  const body = encodeURIComponent(`
Hello Suraasa Team,
I noticed that something is not right with my assessment.
`)
  return `mailto:care@suraasa.com?body=${body}&subject=${subject}`
}

const AssessmentInstructions = ({
  onContinue,
  hasTimer,
}: {
  onContinue: () => void
  hasTimer: boolean
}) => {
  return (
    <>
      <PageContainer className="pb-12 pt-6">
        <Typography variant="title1">Assessment Instructions</Typography>
        <section className="mt-4">
          <Typography variant="title3" className="mb-2">
            Before You Start
          </Typography>
          <ul className="flex list-disc flex-col gap-0.25 ps-2">
            <li>Ensure a stable internet connection.</li>
            <li>
              Make sure your device is charged or connected to a power source.
            </li>
            <li>Find a quiet and well-lit place to take the assessment.</li>
            <li>Close all unnecessary applications on your device.</li>
          </ul>
        </section>
        <section className="mt-4">
          <Typography variant="title3" className="mb-2">
            During the Assessment
          </Typography>
          <ul className="flex list-disc flex-col gap-0.25 ps-2">
            {hasTimer && (
              <li>A countdown timer will be visible on your screen.</li>
            )}
            <li>
              You can navigate between questions using the arrow buttons
              provided at the bottom of the screen.
            </li>
            <li>Your answers are auto-saved.</li>
            <li>
              Click “Submit” when you’re done. Once submitted, changes cannot be
              made.
            </li>
            {hasTimer && <li>If time runs out, the test will auto-submit.</li>}
          </ul>
        </section>
        <section className="mt-4">
          <Typography variant="title3" className="mb-2">
            Important Rules
          </Typography>
          <ul className="flex list-disc flex-col gap-0.25 ps-2">
            <li>Do not refresh or close the app during the test.</li>
            <li>Any suspicious activity may result in disqualification.</li>
            <li>
              Do not use external help, devices, or materials unless allowed.
            </li>
            <li>Avoid switching tabs—your session may be flagged.</li>
          </ul>
        </section>
        <section className="mt-4">
          <Typography variant="title3" className="mb-2">
            Need Help?
          </Typography>
          <p>
            If you experience technical issues, immediately contact support at{" "}
            <a href={getSupportEmailURI()} className="text-interactive-500">
              care@suraasa.com
            </a>
            .
          </p>
        </section>
      </PageContainer>
      <footer
        role="navigation"
        className="
          fixed inset-x-0 bottom-0 z-50 bg-primary-800
          pb-safe
        "
      >
        <PageContainer className="py-2">
          <div className="flex items-center justify-between">
            <Button
              variant="text"
              color={null}
              className="text-white"
              onClick={() => window.close()}
            >
              Close
            </Button>
            <Button variant="filled" onClick={onContinue}>
              Continue
            </Button>
          </div>
        </PageContainer>
      </footer>
    </>
  )
}

export default AssessmentInstructions
